module.exports = __webpack_public_path__ + "img/t4-i1.94b86a6b.svg";